<script lang="ts">
  import { Section } from '@agapi/ui/section';
  import { RichText } from '../../components';
  import { css } from '@agapi/ui/panda/css';
  import { storyblokEditable } from '@storyblok/svelte';
  import type { TextSectionStoryblokProps } from './text-section.types';

  const { blok }: TextSectionStoryblokProps = $props();


  const containerStyles = css.raw({
    textAlign: blok.textAlign,
    py: blok.verticalSpacing,
  });
</script>

<Section
  use={[[storyblokEditable, blok]]}
  colorVariant={blok.colorVariant}
  containerWidth={blok.containerWidth}
  containerStyles={containerStyles}
>
  <RichText blok={blok} />
</Section>
